export const COUNTRY_CODE_COOKIE = 'countryCode';
